/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-breadcrumbs[_ngcontent-%COMP%]{background-color:#edf1f4}.breadcrumbs[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:4px 0 6px}a[_ngcontent-%COMP%], span[_ngcontent-%COMP%]{font-size:11px;font-weight:400;color:#91a3b1;text-decoration:none}span[_ngcontent-%COMP%]{padding:0 2px 0 7px}.disabled[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{pointer-events:none}.breadcrumb[_ngcontent-%COMP%]:last-child   a[_ngcontent-%COMP%]{color:#2c363f}"];
export { styles as styles };
